import { render, staticRenderFns } from "./ClaimList.vue?vue&type=template&id=21fb0c97&scoped=true"
import script from "./ClaimList.vue?vue&type=script&lang=js"
export * from "./ClaimList.vue?vue&type=script&lang=js"
import style0 from "./ClaimList.vue?vue&type=style&index=0&id=21fb0c97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fb0c97",
  null
  
)

export default component.exports